export default {
    ASC: 'ASC',
    DESC: 'DESC'
};



// WEBPACK FOOTER //
// ./src/enums/SortEnum.js